import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, first, of } from 'rxjs';

import { KeyParentTemplate, KeyTemplateParentType } from '../../models';
import { QuestInstanceService } from '../../services';

export const keyParentTemplateResolver: ResolveFn<KeyParentTemplate | null> = (route) => {
  const router = inject(Router);
  const questInstanceService = inject(QuestInstanceService);
  const extrasState = router.currentNavigation()?.extras.state;

  const parentTemplate = extrasState?.['parentTemplate'] as KeyParentTemplate | undefined;
  const parentTemplateType = extrasState?.['parentType'];
  const questInstanceId = route.parent?.parent?.paramMap.get('questInstanceId');
  const parentId = route.queryParamMap.get('parentId');
  const parentType = route.queryParamMap.get('parentType');

  if (!questInstanceId || !parentId || !isKeyTemplateParentType(parentType)) {
    return null;
  }

  if (parentTemplate && parentTemplate.id === parentId && parentTemplateType === parentType) {
    return parentTemplate;
  }

  switch (parentType) {
    case 'PulseTemplate':
      return questInstanceService.getQuestInstancePulseTemplateById(questInstanceId, parentId).pipe(
        first(),
        catchError(() => of(null)),
      );
    case 'SeriesTemplate':
      return questInstanceService.getQuestInstanceSeriesTemplateById(questInstanceId, parentId).pipe(
        first(),
        catchError(() => of(null)),
      );
    default:
      return null;
  }
};

function isKeyTemplateParentType(parentType: string | null): parentType is KeyTemplateParentType {
  return parentType === 'PulseTemplate' || parentType === 'SeriesTemplate';
}
